/**
 * AiOffcanvas.js — opens/closes a [data-ai-open="id"] offcanvas panel. Content
 * inside the panel is static HTML; this only handles open/close and filling
 * the input from a quick-question or follow-up button.
 */
export default class AiOffcanvas {
  constructor() {
    this.triggers = document.querySelectorAll('[data-ai-open]');
    if (!this.triggers.length) return;

    this.triggers.forEach((trigger) => this._bind(trigger));
  }

  _bind(trigger) {
    const panel = document.getElementById(trigger.dataset.aiOpen);
    if (!panel) return;

    const backdrop = panel.querySelector('.ai-offcanvas-backdrop');
    const closeBtn = panel.querySelector('.ai-oc-close');
    const inputField = panel.querySelector('.ai-oc-input input');
    const quickBtns = panel.querySelectorAll('.ai-oc-quick-btn');
    const followupBtns = panel.querySelectorAll('.ai-oc-followup');

    const fillInput = (text) => {
      if (!inputField || !text) return;
      inputField.value = text;
      inputField.focus();
    };

    const open = () => {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const close = () => {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      open();
    });

    backdrop?.addEventListener('click', close);
    closeBtn?.addEventListener('click', close);

    quickBtns.forEach((btn) => btn.addEventListener('click', () => fillInput(btn.dataset.quick)));
    followupBtns.forEach((btn) => btn.addEventListener('click', () => fillInput(btn.querySelector('span')?.textContent)));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });
  }
}
